module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Tablet-1f71f1c75071879d0207c909e3606a0d.svg";